import {
  Component,
  ViewContainerRef,
  TemplateRef,
  OnInit,
  ViewChild,
  ElementRef,
  AfterContentChecked,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../../accountant/accountant.service";
import { DashboardService } from "../../../dashboard.service";
import { EditAppsModalService } from "./edit-apps-modal.service";
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { MyAccountService } from "./my-account-modal.service";
import { FormUtil } from "../../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import * as _ from "underscore";
import moment from "moment";
import { NgIf } from "@angular/common";

@Component({
    selector: "edit-apps-modal-component",
    templateUrl: "./edit-apps-modal.component.html",
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgIf,
    ]
})
export class EditAppsModalComponent implements OnInit, OnChanges {
  app: any = {};
  addAppForm: UntypedFormGroup;
  formUtil: FormUtil;
  fileForm: FormData = new FormData();
  show_other_category = false;
  data: any = {};
  pin: any;
  expired: boolean;
  modalRef: BsModalRef;

  categories = [
    "Accounting",
    "A/P and A/R",
    "Document Retrieval",
    "Receipt Capture",
    "Payroll",
    "Expense Management",
    "Time Tracking",
    "Mileage Tracking",
  ];

  @ViewChild("appInput") appInput: ElementRef;

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private dashboardService: DashboardService,
    private editAppsModalService: EditAppsModalService,
    private formBuilder: UntypedFormBuilder,
    private toastr: HotToastService,
    private localStorage: LocalStorageService,
    private modalService: BsModalService,
    private myAccountService: MyAccountService,
    vcr: ViewContainerRef
  ) {
    this.addAppForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      category: [null, []],
      category_other: [null, []],
      url: [null, []],
      username: [null, []],
      password: [null, []],
    });
  }

  ngOnInit(): void {
    console.log(this.app);
    this.data = this.localStorage.get("data");

    // let now = moment();

    // if (now.isBefore(this.localStorage.get('pin_expires'))) {
    //     this.expired = false;
    // } else {
    //     this.expired = true;
    // }
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.app = changes.app;

    console.log("on changes", this.app);

    this.addAppForm.patchValue({
      name: this.app.name,
      category: this.app.category,
      url: this.app.url,
    });

    // if (this.app.vault != null) {
    //     this.addAppForm.patchValue(
    //         {
    //             username: this.app.vault.username,
    //             password: this.app.vault.password
    //         }
    //     );
    // }

    if (_.find(this.categories, this.app.category) === undefined) {
      this.show_other_category = true;
      this.addAppForm.patchValue({
        category: "Other Category",
        category_other: this.app.category,
      });
    }
  }

  categoryChange(val): void {
    if (val !== "Other Category") {
      this.addAppForm.patchValue({
        category_other: null,
      });

      this.show_other_category = false;
    }
  }

  saveApp(): void {
    this.dashboardService.show_loading.next(true);
    this.fileForm = new FormData();

    if (this.addAppForm.valid) {
      if (this.appInput !== undefined) {
        const fileList: FileList = this.appInput.nativeElement.files;
        if (fileList.length > 0) {
          const file: File = fileList[0];
          this.fileForm.append("file", file, file.name);
        }
      }

      let category =
        this.addAppForm.get("category_other").value !== null
          ? this.addAppForm.get("category_other").value
          : this.addAppForm.get("category").value;

      this.fileForm.append("name", this.addAppForm.get("name").value);
      this.fileForm.append("category", category);
      this.fileForm.append("url", this.addAppForm.get("url").value);
      this.fileForm.append("username", this.addAppForm.get("username").value);
      this.fileForm.append("password", this.addAppForm.get("password").value);

      this.accountantService.edit_app(this.fileForm, this.app.id).then(
        (res) => {
          this.toastr.success("App saved successfully!");
          if (this.appInput !== undefined) {
            this.appInput.nativeElement.value = "";
          }

          this.editAppsModalService.app = res.app;
          this.bsModalRef.hide();
          this.dashboardService.show_loading.next(false);
        },
        (err) => {
          console.log(err);
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        }
      );
    }
  }

  deleteApp(app_id): void {
    this.dashboardService.show_loading.next(true);

    this.accountantService.delete_app(app_id).then(
      (res) => {
        const response = res;
        this.toastr.success("App removed successfully!");

        this.editAppsModalService.delete.next(app_id);

        this.editAppsModalService.app = null;
        this.bsModalRef.hide();
        this.dashboardService.show_loading.next(false);
      },
      (err) => {
        console.log(err);
        this.dashboardService.show_loading.next(false);
        this.toastr.error(err.error.message);
      }
    );
  }

  openConfirmation(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm modal-confirmation",
    });
  }

  confirm(): void {
    this.deleteApp(this.app.id);
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }

  //   unlockPin(): void {
  //       this.myAccountService.check_pin(this.pin).then((res) => {
  //           const response = res;
  //           this.localStorage.set('pin_expires', moment().add(response.timeout, 'minutes').toDate());
  //           this.expired = false;
  //       }, (err) => {
  //           this.toastr.error(err.error.message, 'Error!');
  //       });
  //   }
}
